<div class="container-fluid py-4">
    <div class="row justify-content-center">
        <div class="col-12">
            <!-- Page Header -->
            <div class="card mb-4 shadow-sm border-0">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="icon-circle bg-primary text-white mr-3">
                            <i class="fa fa-file-excel-o fa-lg"></i>
                        </div>
                        <div>
                            <h3 class="mb-1 font-weight-bold text-dark">Bulk Certificate Issuance</h3>
                            <p class="text-muted mb-0">Upload Excel file to issue multiple certificates at once</p>
                        </div>
                    </div>
                </div>
            </div>

            <form [formGroup]="certficateForm" (ngSubmit)="onSubmit()">
                <!-- Template Download Section -->
                <div class="card mb-4 shadow-sm border-0">
                    <div class="card-header bg-dark text-white">
                        <h5 class="mb-0 d-flex align-items-center">
                            <i class="fa fa-download mr-2"></i>
                            Download Templates
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <!-- Alliance Template (Age) - for users who can see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge')">
                                <div class="template-card mb-3" 
                                     [ngClass]="{ 'border-primary bg-light': excelService.hasDetectedTemplate() && excelService.getDetectedTemplate().templateType === 'alliance' && excelService.getDetectedTemplate().brandType === 'age' }">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded"
                                         [ngClass]="{ 'border-primary': excelService.hasDetectedTemplate() && excelService.getDetectedTemplate().templateType === 'alliance' && excelService.getDetectedTemplate().brandType === 'age' }">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-success mr-2"></i>
                                                Alliance Template (Age)
                                                <span *ngIf="excelService.hasDetectedTemplate() && excelService.getDetectedTemplate().templateType === 'alliance' && excelService.getDetectedTemplate().brandType === 'age'" 
                                                      class="badge badge-primary ml-2">
                                                    <i class="fa fa-magic mr-1"></i>Detected
                                                </span>
                                            </h6>
                                            <small class="text-muted">Standard template for age-based entries</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividualAge.xlsx" download="Bulk_Individual_Age.xlsx" 
                                           class="btn btn-outline-success btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Alliance Template (Standard) - for users who cannot see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="!(user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge'))">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-success mr-2"></i>
                                                Alliance Template (Standard)
                                            </h6>
                                            <small class="text-muted">Standard template for certificate entries</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividual.xlsx" download="Bulk_Individual_Standard.xlsx" 
                                           class="btn btn-outline-success btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Honda Template - shown when dealer make is Honda -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Honda' && user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge')">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-danger mr-2"></i>
                                                Honda Template (Age)
                                            </h6>
                                            <small class="text-muted">Honda brand template with age fields</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividualHondaAge.xlsx" download="Honda_Template_Age.xlsx" 
                                           class="btn btn-outline-danger btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Honda Template (Standard) - shown when dealer make is Honda and user cannot see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Honda' && !(user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge'))">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-danger mr-2"></i>
                                                Honda Template (Standard)
                                            </h6>
                                            <small class="text-muted">Honda brand template</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividualHonda.xlsx" download="Honda_Template_Standard.xlsx" 
                                           class="btn btn-outline-danger btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Bajaj Template (Age) - shown when dealer make is Bajaj -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Bajaj' && user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge')">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-warning mr-2"></i>
                                                Bajaj Template (Age)
                                            </h6>
                                            <small class="text-muted">Bajaj brand template with age fields</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividualBajajAge.xlsx" download="Bajaj_Template_Age.xlsx" 
                                           class="btn btn-outline-warning btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Bajaj Template (Standard) - shown when dealer make is Bajaj and user cannot see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Bajaj' && !(user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge'))">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-warning mr-2"></i>
                                                Bajaj Template (Standard)
                                            </h6>
                                            <small class="text-muted">Bajaj brand template</small>
                                        </div>
                                        <a target="_self" href="../../../assets/bulkIndividualBajaj.xlsx" download="Bajaj_Template_Standard.xlsx" 
                                           class="btn btn-outline-warning btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Hero Template (DSL + DOB) - shown when dealer make is Hero and user can see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Hero' && user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge')">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-info mr-2"></i>
                                                Hero Vehicle Sales GST Invoice Template
                                            </h6>
                                            <small class="text-muted">Hero brand template with date of birth fields</small>
                                        </div>
                                        <a target="_self" href="../../../assets/HeroDSL.xlsx" download="Hero_Vehicle_Sales_GST_Invoice_Template.xlsx" 
                                           class="btn btn-outline-info btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Hero Template (DSL) - shown when dealer make is Hero and user cannot see age -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Hero' && !(user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge'))">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-info mr-2"></i>
                                                Hero Vehicle Sales GST Invoice Template
                                            </h6>
                                            <small class="text-muted">Hero brand template for DSL entries</small>
                                        </div>
                                        <a target="_self" href="../../../assets/HeroDSLDOB.xlsx" download="Hero_Vehicle_Sales_GST_Invoice_Template.xlsx" 
                                           class="btn btn-outline-info btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <!-- Hero Ensure Template - shown when dealer make is Hero -->
                            <div class="col-lg-4 col-md-6" *ngIf="showExcel === 'Hero'">
                                <div class="template-card mb-3">
                                    <div class="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <div>
                                            <h6 class="font-weight-bold text-dark mb-1">
                                                <i class="fa fa-file-excel text-success mr-2"></i>
                                                Hero Ensure Template
                                            </h6>
                                            <small class="text-muted">Hero Ensure template with comprehensive policy data</small>
                                        </div>
                                        <a target="_self" href="../../../assets/BulkIndividualHeroEnsureTemplate.xls" download="BulkIndividualHeroEnsureTemplate.xls" 
                                           class="btn btn-outline-success btn-sm">
                                            <i class="fa fa-download mr-1"></i>
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="alert alert-info mt-3">
                            <i class="fa fa-info-circle mr-2"></i>
                            <strong>Important:</strong> Please download the appropriate template for your data entry. 
                            Ensure all required fields including Date of Birth are properly filled.
                        </div>
                    </div>
                </div>

                <!-- Plan Configuration Section -->
                <div class="card mb-4 shadow-sm border-0">
                    <div class="card-header bg-info text-white">
                        <h5 class="mb-0 d-flex align-items-center">
                            <i class="fa fa-cogs mr-2"></i>
                            Plan Configuration
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group">
                                    <label for="planId" class="font-weight-bold text-dark">
                                        <i class="fa fa-bookmark text-primary mr-1"></i>
                                        Select Plan <span class="text-danger">*</span>
                                    </label>
                                    <select class="form-control form-control-lg" formControlName="planId" 
                                            [ngClass]="{ 'is-invalid': submitted && f.planId.errors }">
                                        <option value="" disabled>Choose a plan...</option>
                                        <option *ngFor="let plan of plans" [ngValue]="plan.planId">
                                            {{ plan.planId }}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.planId.errors" class="invalid-feedback">
                                        <div *ngIf="f.planId.errors.required">Plan selection is required</div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Finance Company (if applicable) -->
                            <div class="col-lg-4 col-md-6" *ngIf="showFinance">
                                <div class="form-group position-relative">
                                    <label for="financeCompanyName" class="font-weight-bold text-dark">
                                        <i class="fa fa-university text-success mr-1"></i>
                                        Finance Company <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" formControlName="financeCompanyName" 
                                           class="form-control form-control-lg" 
                                           placeholder="Type to search finance companies..."
                                           [ngClass]="{ 'is-invalid': submitted && f.financeCompanyName.errors }" />
                                    <div class="position-absolute w-100" style="z-index: 1050; top: 100%;" 
                                         *ngIf="selectedFinanceCompanies.length > 0 && f.financeCompanyName.value != selectedFinance">
                                        <div class="dropdown-menu show w-100 shadow-lg border">
                                            <a class="dropdown-item" href="#" 
                                               (click)="financeSelected(fin); $event.preventDefault()"  
                                               *ngFor="let fin of selectedFinanceCompanies">
                                                <i class="fa fa-building mr-2"></i>{{fin}}
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.financeCompanyName.errors" class="invalid-feedback">
                                        <div *ngIf="f.financeCompanyName.errors.required">Finance Company Name is required</div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Finance Cover Amount -->
                            <div class="col-lg-4 col-md-6" *ngIf="showFinance">
                                <div class="form-group">
                                    <label for="financeCoverAmount" class="font-weight-bold text-dark">
                                        <i class="fa fa-shield text-warning mr-1"></i>
                                        Finance Cover Amount
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">₹</span>
                                        </div>
                                        <input type="number" formControlName="financeCoverAmount" 
                                               class="form-control form-control-lg" 
                                               [ngClass]="{ 'is-invalid': submitted && f.financeCoverAmount.errors }" />
                                    </div>
                                    <div *ngIf="submitted && f.financeCoverAmount.errors" class="invalid-feedback">
                                        <div *ngIf="f.financeCoverAmount.errors">
                                            Finance Cover amount is required and cannot exceed ₹{{selectedPlan.planCPACoverAmount | number}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Plan Amount Details -->
                        <div class="row" *ngIf="selectedPlan.planId">
                            <div class="col-lg-3 col-md-6" *ngIf="showGstAmount">
                                <div class="form-group">
                                    <label for="planAmount" class="font-weight-bold text-dark">
                                        <i class="fa fa-money text-success mr-1"></i>
                                        Plan Amount
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">₹</span>
                                        </div>
                                        <input type="number" formControlName="planAmount" 
                                               class="form-control" readonly
                                               [ngClass]="{ 'is-invalid': submitted && f.planAmount.errors }" />
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-3 col-md-6" *ngIf="showGstAmount">
                                <div class="form-group">
                                    <label for="planGSTAmount" class="font-weight-bold text-dark">
                                        <i class="fa fa-percent text-info mr-1"></i>
                                        GST Amount
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">₹</span>
                                        </div>
                                        <input type="number" formControlName="planGSTAmount" 
                                               class="form-control" readonly
                                               [ngClass]="{ 'is-invalid': submitted && f.planGSTAmount.errors }" />
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-3 col-md-6">
                                <div class="form-group">
                                    <label for="planTotalAmount" class="font-weight-bold text-dark">
                                        <i class="fa fa-calculator text-primary mr-1"></i>
                                        Total Amount <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-primary text-white">₹</span>
                                        </div>
                                        <input type="number" formControlName="planTotalAmount" 
                                               class="form-control form-control-lg font-weight-bold" 
                                               [ngClass]="{ 'is-invalid': submitted && f.planTotalAmount.errors }" />
                                    </div>
                                    <div *ngIf="submitted && f.planTotalAmount.errors" class="invalid-feedback">
                                        <div *ngIf="f.planTotalAmount.errors">
                                            Amount must be between ₹{{minAmount | number}} and ₹{{maxAmount | number}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Date Selection Section -->
                <div class="card mb-4 shadow-sm border-0">
                    <div class="card-header bg-primary text-white">
                        <h5 class="mb-0 d-flex align-items-center">
                            <i class="fa fa-calendar mr-2"></i>
                            Certificate Dates & Balance
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-3 col-md-6">
                                <div class="form-group">
                                    <label for="startDate" class="font-weight-bold text-dark">
                                        <i class="fa fa-calendar-plus text-success mr-1"></i>
                                        Start Date <span class="text-danger">*</span>
                                    </label>
                                    <div class="input-group">
                                        <input class="form-control" formControlName="startDate"  
                                               placeholder="DD/MM/YYYY" [minDate]="startDateModel" 
                                               ngbDatepicker #d1="ngbDatepicker" 
                                               [ngClass]="{ 'is-invalid': submitted && f.startDate.errors }">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary" (click)="d1.toggle()" type="button">
                                                <i class="fa fa-calendar"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.startDate.errors" class="invalid-feedback">
                                        <div *ngIf="f.startDate.errors.required">Start Date is required</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-3 col-md-6">
                                <div class="form-group">
                                    <label for="endDate" class="font-weight-bold text-dark">
                                        <i class="fa fa-calendar-times text-danger mr-1"></i>
                                        End Date
                                    </label>
                                    <input type="text" formControlName="endDate" 
                                           class="form-control" readonly
                                           placeholder="Auto-calculated"
                                           [ngClass]="{ 'is-invalid': submitted && f.endDate.errors }" />
                                    <small class="form-text text-muted">
                                        <i class="fa fa-info-circle"></i> Based on plan duration
                                    </small>
                                </div>
                            </div>
                            
                            <div class="col-lg-3 col-md-6">
                                <div class="form-group">
                                    <label for="issueDate" class="font-weight-bold text-dark">
                                        <i class="fa fa-calendar-check text-info mr-1"></i>
                                        Issue Date
                                    </label>
                                    <input type="text" formControlName="issueDate" 
                                           class="form-control" readonly
                                           placeholder="Auto-set"
                                           [ngClass]="{ 'is-invalid': submitted && f.issueDate.errors }" />
                                </div>
                            </div>
                            
                            <div class="col-lg-3 col-md-6" *ngIf="!(user.specialRoleAccess && user.specialRoleAccess.includes('CannotViewDealerBalance'))">
                                <div class="form-group">
                                    <label for="balance" class="font-weight-bold text-dark">
                                        <i class="fa fa-wallet text-warning mr-1"></i>
                                        Balance
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">₹</span>
                                        </div>
                                        <input type="text" formControlName="balance" 
                                               class="form-control" readonly
                                               [ngClass]="{ 'is-invalid': isBalanceLow }" />
                                    </div>
                                    <div *ngIf="isBalanceLow" class="text-danger small mt-1">
                                        <i class="fa fa-exclamation-triangle"></i>
                                        Balance is running low. Please add money before proceeding
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- File Upload Section -->
                <div class="card mb-4 shadow-sm border-0">
                    <div class="card-header bg-warning text-dark">
                        <h5 class="mb-0 d-flex align-items-center">
                            <i class="fa fa-upload mr-2"></i>
                            File Upload & Processing
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="form-group">
                                    <label for="uploadFile" class="font-weight-bold text-dark">
                                        <i class="fa fa-file-excel text-success mr-1"></i>
                                        Upload Excel File <span class="text-danger">*</span>
                                    </label>
                                    <div class="custom-file">
                                        <input type="file" 
                                               formControlName="uploadFile" 
                                               (change)="onFileChange($event)" 
                                               class="custom-file-input" 
                                               id="uploadFile"
                                               [ngClass]="{ 'is-invalid': submitted && f.uploadFile.errors }" 
                                               accept=".xlsx,.xls" />
                                        <label class="custom-file-label" for="uploadFile">
                                            Choose Excel file...
                                        </label>
                                    </div>
                                    <small class="form-text text-muted">
                                        <i class="fa fa-info-circle"></i>
                                        Please upload Excel files (.xlsx or .xls) only. Maximum file size: 10MB
                                        <br>
                                        <strong>Date Formats Supported:</strong> DD-MM-YYYY, DD/MM/YYYY, DD.MM.YYYY, or DD/MM/YY (e.g., 01-01-1990, 1/1/90, 01.01.1990)
                                    </small>
                                    <div *ngIf="submitted && f.uploadFile.errors" class="invalid-feedback">
                                        <div *ngIf="f.uploadFile.errors.required">File is required</div>
                                    </div>
                                    
                                    <!-- File Processing Status -->
                                    <div *ngIf="certificates && certificates.length > 0" class="mt-3">
                                        <div class="alert alert-success d-flex align-items-center">
                                            <i class="fa fa-check-circle fa-2x mr-3"></i>
                                            <div>
                                                <h6 class="mb-1">File Processed Successfully!</h6>
                                                <p class="mb-0">
                                                    Successfully loaded <strong>{{certificates.length}}</strong> certificate(s) from file
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Template Detection Display -->
                                    <div *ngIf="excelService.hasDetectedTemplate() && !error" class="mt-3">
                                        <div class="alert alert-info d-flex align-items-center">
                                            <i class="fa fa-magic fa-2x mr-3"></i>
                                            <div>
                                                <h6 class="mb-1">
                                                    <i class="fa fa-check-circle text-success mr-1"></i>
                                                    Template Auto-Detected
                                                </h6>
                                                <p class="mb-0">
                                                    <strong>{{excelService.getDetectedTemplate().displayName}}</strong>
                                                    <br>
                                                    <small class="text-muted">
                                                        The system automatically identified your template based on the column headers in your Excel file.
                                                        This ensures optimal processing and validation for your data.
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Error Display -->
                                    <div *ngIf="error" class="mt-3">
                                        <div class="alert alert-danger d-flex align-items-center">
                                            <i class="fa fa-exclamation-triangle fa-2x mr-3"></i>
                                            <div>
                                                <h6 class="mb-1">Processing Error</h6>
                                                <p class="mb-0" *ngIf="error !== true && error !== 'true'">{{error}}</p>
                                                <p class="mb-0" *ngIf="error === true || error === 'true'">
                                                    Please check the alert message at the top of the page for detailed error information.
                                                    <br>
                                                    <small class="text-muted">
                                                        <i class="fa fa-arrow-up mr-1"></i>
                                                        Scroll to the top to view the complete error details.
                                                    </small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="templateType" class="font-weight-bold text-dark">
                                        <i class="fa fa-tags text-primary mr-1"></i>
                                        Template Type
                                    </label>
                                    <select class="form-control form-control-lg" formControlName="templateType">
                                        <option *ngFor="let template of templateTypes" [value]="template">
                                            {{ template }}
                                        </option>
                                    </select>
                                    <small class="form-text text-muted">
                                        <i class="fa fa-info-circle"></i>
                                        Select the appropriate template format
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Form Actions -->
                <div class="card shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div class="mr-3 mb-2 mb-lg-0">
                                <h6 class="mb-0 text-dark font-weight-bold">
                                    <i class="fa fa-info-circle text-info mr-2"></i>
                                    Ready to process {{certificates?.length || 0}} certificate(s)
                                </h6>
                                <small class="text-muted">
                                    Ensure all fields are properly filled before submitting
                                </small>
                            </div>
                            <div class="d-flex flex-wrap">
                                <button type="button" 
                                        class="btn btn-outline-secondary mr-2 mb-2 mb-lg-0" 
                                        (click)="resetForm()">
                                    <i class="fa fa-refresh mr-1"></i>
                                    Reset Form
                                </button>
                                <button [disabled]="loading || isBalanceLow || error || !certificates || certificates.length === 0" 
                                        class="btn btn-primary btn-lg px-4" 
                                        type="submit">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2"></span>
                                    <i class="fa fa-certificate mr-2" *ngIf="!loading"></i>
                                    {{loading ? 'Processing...' : 'Issue ' + (certificates?.length || 0) + ' Certificate(s)'}}
                                </button>
                                <a routerLink="/bulkIndividual" class="btn btn-outline-danger ml-2 mb-2 mb-lg-0">
                                    <i class="fa fa-times mr-1"></i>
                                    Cancel
                                </a>
                            </div>
                        </div>
                        
                        <!-- Status indicators -->
                        <div class="mt-3" *ngIf="isBalanceLow">
                            <div class="alert alert-warning d-flex align-items-center">
                                <i class="fa fa-exclamation-triangle fa-2x mr-3"></i>
                                <div>
                                    <h6 class="mb-1">Low Balance Warning</h6>
                                    <p class="mb-0">Balance is running low. Please add money before proceeding.</p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="mt-3" *ngIf="!certificates || certificates.length === 0">
                            <div class="alert alert-info d-flex align-items-center">
                                <i class="fa fa-info-circle fa-2x mr-3"></i>
                                <div>
                                    <h6 class="mb-1">Upload Required</h6>
                                    <p class="mb-0">Please upload a valid Excel file with certificate data to proceed.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
